import { useMemo, useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Color from 'color';
import { useTheme } from '@material-ui/core/styles';

export default function FinancingWebComponent({ onCompanyFetched, ...props }) {
  const theme = useTheme();
  const financingElement = useRef();
  const [stop, setStop] = useState(true);

  const style = useMemo(() => {
    const primary = new Color(theme.palette.primary.main);
    const primaryContrast = new Color(theme.palette.primary.contrastText);
    const error = new Color(theme.palette.error.main);

    const parsedEntries = [
      ['--primary', primary],
      ['--primary-contrast', primaryContrast],
      ['--error', error],
    ].map(([name, color]) => [
      name,
      `${color.red()},${color.green()},${color.blue()}`,
    ]);

    return Object.fromEntries(parsedEntries);
  }, []);

  useEffect(() => {
    financingElement.current.addEventListener('company-fetched', ({ detail }) => {
      if (onCompanyFetched) {
        onCompanyFetched(detail);
      }
    });
    setStop(false);
  }, [financingElement, onCompanyFetched]);

  return (
    <intelimotor-financing
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      stop={`${stop}`}
      ref={financingElement}
      style={style}
    />
  );
}

FinancingWebComponent.propTypes = {
  onCompanyFetched: PropTypes.func,
};

FinancingWebComponent.defaultProps = {
  onCompanyFetched: null,
};
